import {defineMessages} from "react-intl";

const messages = defineMessages({
    yes:{
	id:"app.admin-create-health-admin-modal.yes",
	description:"yes",
	defaultMessage:"ADD"
    },
    
    city:{
	id:"app.admin-create-health-admin-modal.city",
	description:"Update Status",
	defaultMessage:"City"
    },

    healthAdmin:{
	id:"app.admin-create-health-admin-modal.admin",
	description:"Update Status",
	defaultMessage:"Health Admin"
    },

    healthDistrict:{
	id:"app.admin-create-health-admin-modal.district",
	description:"Update Status",
	defaultMessage:"Health District"
    }
    
});

export default messages;
